export const sanitize = (string = '') => {
  const newString = string
    .replace(new RegExp(/(<([^>]+)>)/gi), '')
    .replace(new RegExp(/&nbsp;/gi), ' ')
    .replace(new RegExp(/&amp;/gi), '&')
  return newString
}
